import { connect } from 'react-redux';

import BranchesView from '../components/BranchesView';

const mapActionCreators = {};

const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    mapActionCreators
)(BranchesView);
